const siteUrl = 'https://www.parentool.cn'

export const buildCanonicalUrl = (pathname: string) => {
  return pathname === '/' ? `${siteUrl}/` : `${siteUrl}${pathname}`
}

export const buildHomeStructuredData = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Parentool 工具站',
  url: `${siteUrl}/`,
  description: 'Parentool 提供亲子资料库、在线工具、纳指看板和亲子资源库。'
})

export const buildToolStructuredData = (tool: {
  name: string
  description: string
  path: string
  status?: string
  category: string
}) => {
  if (tool.status !== 'ready') return null

  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: tool.name,
    description: tool.description,
    applicationCategory: tool.category,
    operatingSystem: 'Web',
    url: buildCanonicalUrl(tool.path),
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'CNY'
    }
  }
}

export const buildFaqStructuredData = (items: Array<{ question: string; answer: string }>) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: items.map(item => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer
    }
  }))
})
